import { ObjectId } from 'lib_ui-services';
import getShortProfileForMeta from '../../../utilities/getShortProfileForMeta';

export default {
    verb: 'willRemove',
    namespace: 'application',
    relation: 'notification',
    prerequisites: [],
    description: 'Prepare to remove the given record on the database',
    //this is the actual logic:
    logic
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 * }} parameters
 * @returns {T}
 */
async function logic({ data, context }) {
    const id = data._id || data.id;
    const currentTime = new Date().toISOString();
    const currentUser = getShortProfileForMeta(context);
    // @ts-ignore
    context.correlationId = context.correlationId || new ObjectId().toString();
    const meta = { deleted: true, deletedBy: currentUser, deletedTime: currentTime };
    return { id, meta };
}
